import { defineAsyncComponent } from 'vue';
import { userPermission } from '@/constants';
import { pageAuthorization } from '@/router-middleware';
import basicOptions from '@/router/basic-options';
import DividedDialogs from '@/views/Temporary/DividedDialogs.vue';
import Temporary from '@/views/Temporary/index.vue';
export default [
    {
        path: 'temporary',
        name: 'Temporary',
        component: Temporary,
        redirect: {
            name: 'Foo',
        },
        meta: {
            ...basicOptions,
        },
        children: [
            {
                path: 'downloader',
                name: 'Downloader',
                component: defineAsyncComponent(() => import('@/views/Temporary/Downloader.vue')),
                meta: {
                    ...basicOptions,
                },
            },
            {
                path: 'validation-composition-api',
                name: 'ValidationCompositionApi',
                component: defineAsyncComponent(() => import('@/views/Temporary/ValidationCompositionApi.vue')),
                meta: {
                    ...basicOptions,
                },
            },
            {
                path: 'validation-option-api',
                name: 'ValidationOptionApi',
                component: defineAsyncComponent(() => import('@/views/Temporary/ValidationOptionApi.vue')),
                meta: {
                    ...basicOptions,
                },
            },
            {
                path: 'divided-dialogs',
                name: 'DividedDialogs',
                component: DividedDialogs,
            },
            {
                path: 'foo',
                name: 'Foo',
                component: defineAsyncComponent(() => import('@/views/Temporary/Foo.vue')),
                meta: {
                    ...basicOptions,
                },
            },
            {
                path: 'bar',
                name: 'Bar',
                component: defineAsyncComponent(() => import('@/views/Temporary/Bar.vue')),
            },
            {
                path: 'baz',
                name: 'Baz',
                component: defineAsyncComponent(() => import('@/views/Temporary/Baz.vue')),
                meta: {
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_TEMPORARY,
                        ]),
                    ],
                },
            },
        ],
    },
    {
        path: 'temporary2',
        name: 'Temporary2',
        template: '<div>P_GET_TEMPORARY2가 있어야 볼 수 있음</div>',
        meta: {
            middleware: [
                pageAuthorization([
                    userPermission.P_GET_TEMPORARY2,
                ]),
            ],
        },
    },
];
